import React, { Fragment } from "react";
import Pagination from "assets/scripts/components/presentational/Pagination/Pagination";
import Table from "assets/scripts/components/presentational/Table/Table";
import { defineMessages, FormattedNumber, FormattedMessage } from "react-intl";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import styles from "./PaymentAmountTable.module.less";
const ITEMS_PER_PAGE = 10;
const messages = defineMessages({
    paymentAmount: {
        id: "receipt.paymentAmount",
        defaultMessage: "Payment Amount"
    },
    creditor: {
        id: "receipt.creditor",
        defaultMessage: "Creditor"
    },
    accountNumber: {
        id: "amountTable.accountNumber",
        defaultMessage: "Account Number"
    }
});
const PaymentAmountTable = (props) => {
    const columns = [];
    if (process.env.CLIENT == null || props.amounts.some(it => it.creditor != null)) {
        columns.push({
            header: messages.creditor,
            value: it => it.creditor,
            size: "m"
        });
    }
    columns.push({
        header: messages.accountNumber,
        value: it => <AccountNumber value={it.accountNumber}/>,
        size: "m"
    }, {
        header: messages.paymentAmount,
        value: ({ amount }) => (<FormattedNumber value={amount} style="currency" currency="USD"/>),
        size: "s"
    });
    return (<Fragment>
			<Pagination items={props.amounts} itemsPerPage={ITEMS_PER_PAGE}>
				{({ page, renderPager, pageIndex }) => (<div className={styles.wrapper}>
						<Table items={page} columns={columns} srLabel="Account" srLabelPlural="Accounts" pageIndex={pageIndex} itemsPerPage={ITEMS_PER_PAGE} getKey={it => it.payableId}/>
						{renderPager("Account")}
					</div>)}
			</Pagination>
			<table className={styles.fullTable}>
				<thead>
					<tr>
						{columns.map(({ header }, index) => (<th key={index}>
								<FormattedMessage {...header}/>
							</th>))}
					</tr>
				</thead>
				<tbody>
					{props.amounts.map(amount => (<tr key={amount.payableId}>
							{columns.map(({ value }, index) => (<td key={index}>
									{value(amount)}
								</td>))}
						</tr>))}
				</tbody>
			</table>
		</Fragment>);
};
export default PaymentAmountTable;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/PaymentAmountTable/PaymentAmountTable.tsx